/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `SUBJEKT_EVIDENCE_DTI` - Subjekt evidence DTI
 *   * `EDITOR_ZPS` - Editor ZPS
 *   * `IS_DTMK` - IS DTMK
 *   * `AZI` - AZI
 *   * `OPRAVNENY_ZADATEL` - Oprávněný žadatel
 *   * `BUDOUCI_STAVEBNIK` - Budoucí stavebník
 * ```
 */
export const RegistryEnum = {
  SUBJEKT_EVIDENCE_DTI: 'SUBJEKT_EVIDENCE_DTI',
  EDITOR_ZPS: 'EDITOR_ZPS',
  IS_DTMK: 'IS_DTMK',
  AZI: 'AZI',
  OPRAVNENY_ZADATEL: 'OPRAVNENY_ZADATEL',
  BUDOUCI_STAVEBNIK: 'BUDOUCI_STAVEBNIK',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RegistryEnum = ValuesOf<typeof RegistryEnum>;

export type RegistryEnumRequest = RegistryEnum;
export type RegistryEnumResponse = RegistryEnum;
